import { gql } from '@apollo/client';

export default gql`
  mutation markAllNotificationsReadStatus($isRead: Boolean!) @client {
    markAllNotificationsReadStatus(input: { isRead: $isRead })
  }
`;
